var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10703_36760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3224 11.7554C13.4886 10.7848 11.7328 9.89253 9.93799 8.96094V14.534C11.8267 13.5171 13.8174 12.5859 15.3302 11.7554H15.3224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3224 11.7554C13.4886 10.7848 9.93799 8.96094 9.93799 8.96094L14.6719 12.1122C14.6723 12.1122 13.8096 12.5859 15.3224 11.7554Z",
    fill: "#E8E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2831 18.8942C6.47417 18.8247 5.17324 18.7622 4.37361 18.5991C3.83261 18.4907 3.36248 18.25 3.01777 17.9008C2.75135 17.6366 2.53948 17.2335 2.3751 16.6741C2.2341 16.2082 2.17918 15.8205 2.10089 14.8734C1.98104 12.7361 1.95246 10.9887 2.10089 9.03617C2.22334 7.95795 2.2827 6.67797 3.09606 5.93123C3.48011 5.58174 3.92686 5.35684 4.42853 5.26386C5.2122 5.1165 8.55098 5 12.0074 5C15.456 5 18.8022 5.1165 19.5866 5.26386C20.2133 5.38036 20.8011 5.72947 21.1462 6.17965C21.8883 7.33578 21.9013 8.77342 21.9766 9.89794C22.0078 10.4337 22.0078 13.4762 21.9766 14.012C21.8593 15.7892 21.7651 16.418 21.4987 17.0699C21.3339 17.4815 21.1933 17.6987 20.9499 17.9394C20.5681 18.3098 20.0814 18.5562 19.5547 18.6457C16.2586 18.8912 13.4597 18.9445 10.2831 18.8942ZM15.3306 11.753C13.4968 10.7825 11.741 9.88251 9.94616 8.95092V14.5243C11.8348 13.5075 13.8259 12.5759 15.3384 11.7453L15.3306 11.753Z",
    fill: "#CD201F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10703_36760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.913,
    fill: "white",
    transform: "translate(2 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.8df54cdfa46e384c8beb491a7889e3c7.svg";
export { ForwardRef as ReactComponent };